"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getDeletedPatchByActivityTags = function getDeletedPatchByActivityTags(patch, tags) {
  var deletedPatch = {};
  Object.keys(patch).forEach(function (key) {
    var filteredEntities = patch[key].filter(function (entity) {
      return entity.__tags__ && entity.__tags__.length > 0 && entity.__tags__.every(function (tag) {
        return tags.includes(tag);
      });
    });
    deletedPatch[key] = filteredEntities;
  });
  return deletedPatch;
};

var _default = getDeletedPatchByActivityTags;
exports["default"] = _default;